'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { isBlockByName } from '../../dom/index.js';
import { DEFAULT_BLOCK_ELEMENT } from '../../dom/parseBlockAttributes.js';
import { useBlock, useBlockAttributes } from './hooks/index.js';
export function ListBlock({ domNode: node = DEFAULT_BLOCK_ELEMENT, children, component: Component, style, }) {
    const { name, className, attributes } = useBlock(node);
    const blockAttributes = useBlockAttributes(node);
    return (_jsx(Component, { name: name, domNode: node, className: className, htmlAnchor: node.attribs.id || '', ordered: !!attributes.ordered, attributes: blockAttributes, style: style, children: children }));
}
/**
 * @internal
 */
// eslint-disable-next-line no-redeclare
(function (ListBlock) {
    ListBlock.defaultProps = {
        test: (node) => {
            return isBlockByName(node, 'core/list');
        },
    };
})(ListBlock || (ListBlock = {}));
